// src/views/Settings/user/SecuritySection.jsx
//
// Contraseña y borrado de cuenta. El borrado estaba dentro del panel de
// privacidad; es de seguridad, y aquí es donde se busca.
import React from 'react';
import SectionHeader from '../SectionHeader';
import UserSettingsPanels from './UserSettingsPanels';

export default function SecuritySection() {
  return (
    <>
      <SectionHeader
        title="Security"
        subtitle="Your password, and how to close your account for good."
      />
      <UserSettingsPanels panels={['password', 'delete']} />
    </>
  );
}
